/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Payment_Timeout_ContnetInputs */

const en_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment timed out or incomplete. Please check your internet connection and try again, or refer to the FAQ.`)
};

const ar_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهت مهلة الدفع أو لم تكتمل. يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى، أو الرجوع إلى الأسئلة الشائعة.`)
};

const de_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zahlung wurde abgebrochen oder ist unvollständig. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut, oder lesen Sie die FAQ.`)
};

const es_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pago ha caducado o está incompleto. Comprueba tu conexión a Internet e inténtalo de nuevo, o consulta las preguntas frecuentes.`)
};

const fr_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement interrompu ou incomplet. Veuillez vérifier votre connexion internet et réessayez, ou consultez la FAQ.`)
};

const it_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento scaduto o incompleto. Controlla la tua connessione Internet e riprova, oppure consulta le FAQ.`)
};

const ja_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お支払いがタイムアウトまたは未完了となっています。インターネット接続を確認してから再度お試しいただくか、よくある質問をご参照ください。`)
};

const ko_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제 시간이 초과되었거나 완료되지 않았어요. 인터넷 연결을 확인한 후 다시 시도하거나 FAQ를 참조하세요.`)
};

const pt_br_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento não concluído ou tempo esgotado. Verifique sua conexão com a internet e tente novamente ou consulte as Perguntas Frequentes.`)
};

const ru_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время ожидания платежа истекло, или платеж не был завершен. Проверьте интернет-подключение и повторите попытку или обратитесь к часто задаваемым вопросам.`)
};

const th_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การชำระเงินหมดเวลาหรือไม่เสร็จสมบูรณ์ โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณแล้วลองอีกครั้ง หรือดูคำถามที่พบบ่อย`)
};

const tr_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödeme zaman aşımına uğradı veya tamamlanmadı. Lütfen internet bağlantını kontrol edip tekrar dene veya SSS bölümüne bakın.`)
};

const zh_cn_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款超时或未完成，请检查网络并重试或参考常见问题。`)
};

const zh_tw_dialog_payment_timeout_contnet = /** @type {(inputs: Dialog_Payment_Timeout_ContnetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款超時或未完成，請檢查網路並重試或參考常見問題。`)
};

/**
* | output |
* | --- |
* | "Payment timed out or incomplete. Please check your internet connection and try again, or refer to the FAQ." |
*
* @param {Dialog_Payment_Timeout_ContnetInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_payment_timeout_contnet = /** @type {((inputs?: Dialog_Payment_Timeout_ContnetInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Payment_Timeout_ContnetInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_payment_timeout_contnet(inputs)
	if (locale === "ar") return ar_dialog_payment_timeout_contnet(inputs)
	if (locale === "de") return de_dialog_payment_timeout_contnet(inputs)
	if (locale === "es") return es_dialog_payment_timeout_contnet(inputs)
	if (locale === "fr") return fr_dialog_payment_timeout_contnet(inputs)
	if (locale === "it") return it_dialog_payment_timeout_contnet(inputs)
	if (locale === "ja") return ja_dialog_payment_timeout_contnet(inputs)
	if (locale === "ko") return ko_dialog_payment_timeout_contnet(inputs)
	if (locale === "pt_br") return pt_br_dialog_payment_timeout_contnet(inputs)
	if (locale === "ru") return ru_dialog_payment_timeout_contnet(inputs)
	if (locale === "th") return th_dialog_payment_timeout_contnet(inputs)
	if (locale === "tr") return tr_dialog_payment_timeout_contnet(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_payment_timeout_contnet(inputs)
	return zh_tw_dialog_payment_timeout_contnet(inputs)
});